var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsSolid = function SvgIconsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v22h22V5Zm2 2h8v8H7Zm10 0h8v8h-8Zm-6 2-3 4h6Zm8 0v4h4V9ZM7 17h8v8H7Zm10 0h8v8h-8Zm4 1-2 3 2 3 2-3Zm-10 1a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4"
  })));
};
export default SvgIconsSolid;